import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  Card,
  CardHeader,
  Heading,
  CardBody,
  HStack,
  Link,
  CardProps,
  VStack,
} from "@chakra-ui/react";

import { AuxiliaryComponent, getHumanReadableAuxPartType } from "@constants";
import {
  CardDivider,
  IconTagPassed,
  IconTagFailed,
  IconTagLocation,
  PlainTag,
} from "@components";

type ComponentGridItemProps = CardProps & {
  auxComponent: AuxiliaryComponent;
};

export function ComponentGridItem({
  auxComponent,
  ...delegated
}: ComponentGridItemProps) {
  return (
    <Card {...delegated}>
      <CardHeader as={VStack} gap="sm" alignItems="flex-start">
        <Heading as="h3" size="md">
          <Link
            as={ReactRouterLink}
            to={`/auxiliary-components/${auxComponent.id}`}
          >
            {auxComponent.id}
          </Link>
        </Heading>
        <PlainTag
          text={getHumanReadableAuxPartType(auxComponent.componentType)}
        />
      </CardHeader>
      <CardDivider />
      <CardBody as={HStack} alignItems="flex-start">
        {auxComponent.status === "OKAY" ? <IconTagPassed text="Okay" /> : null}
        {auxComponent.status === "DO_NOT_USE" ? (
          <IconTagFailed text="Scrapped" />
        ) : null}
        <IconTagLocation location={auxComponent.location} />
      </CardBody>
    </Card>
  );
}
